import { section } from "@/glow";
import { animateScrollingContent, shouldAnimate } from "@/lib/animation";

section("scrolling-content", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateScrollingContent = animateScrollingContent(this.container);
    }
  },

  onUnload() {
    this.animateScrollingContent?.destroy();
  },
});
